import SuggestedBrowsers from './SuggestedBrowsers';

import './index.css';

export default SuggestedBrowsers;
